module.exports = __webpack_public_path__ + "static/media/RN-2025-03.543313c0.jpg";